export default "__VITE_PUBLIC_ASSET__1893c50d__"